<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 700px">
            <!--<v-responsive :aspect-ratio="16 / 9">-->
            <v-card-title primary-title>
              <div>
                <div class="headline pl-2 pa-1">{{ $t("settings.settings.adminSettings") }}</div>
              </div>
            </v-card-title>
            <v-flex>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">

                <label style="font-size: large">{{ $t("settings.settings.instantSuggestionTime") }}</label>
                <v-text-field outline v-model="model.instantSuggestion" :label="$t('settings.settings.instantSuggestionValue')" type="number"
                  style="margin-top: 15px"></v-text-field>


                <label style="font-size: large">{{ $t("settings.settings.reservationSuggestionTime") }}</label>
                <v-text-field outline v-model="model.reservationSuggestion" :label="$t('settings.settings.reservationSuggestionValue')"
                  type="number" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settings.settings.lemonwayIdLabel") }}</label>
                <v-text-field outline v-model="model.lemonwayId" :label="$t('settings.settings.lemonwayId')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settings.settings.minimumBesoin") }}</label>
                <v-text-field outline v-model="model.besoin" :label="$t('settings.settings.besoinValue')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settings.settings.minimumInstant") }}</label>
                <v-text-field outline v-model="model.instant" :label="$t('settings.settings.instantValue')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settings.settings.minimumRedistribution") }}</label>
                <v-text-field outline v-model="model.redistribute" :label="$t('settings.settings.redistributionLimit')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settings.settings.geoFenceRadius") }}</label>
                <v-text-field outline v-model="model.geo_fence" :label="$t('settings.settings.geoFenceClient')" type="text"
                  style="margin-top: 15px"></v-text-field>
                <label style="font-size: large">{{ $t("settings.settings.blockTime") }}</label>
                <v-text-field outline v-model="model.block_period" :label="$t('settings.settings.blockingTime')" type="text"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settings.settings.companyEmailLabel") }}</label>
                <v-text-field outline v-model="model.company_email" :label="$t('settings.settings.companyEmail')" type="text"
                  style="margin-top: 15px"></v-text-field>
                <label style="font-size: large">{{ $t("settings.settings.allowShortReservation") }}</label>
                <v-switch color="red" v-model="model.short_reservation" :false-value="0" :true-value="1"></v-switch>

              

                <label style="font-size: large">{{ $t("settings.settings.pricePerMinuteLabel") }}</label>
                <v-text-field outline v-model="model.price_per_minute" :label="$t('settings.settings.pricePerMinute')" type="number"
                  style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settings.settings.minorVersionAndroidLabel") }}</label>
                <v-text-field outline v-model="model.customerAppMinorVersionAndroid" :label="$t('settings.settings.minorVersionAndroid')"
                  type="text" style="margin-top: 15px"></v-text-field>
                <label style="font-size: large">{{ $t("settings.settings.majorVersionAndroidLabel") }}</label>
                <v-text-field outline v-model="model.customerAppMajorVersionAndroid" :label="$t('settings.settings.majorVersionAndroid')"
                  type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settings.settings.minorVersionIosLabel") }}</label>
                <v-text-field outline v-model="model.customerAppMinorVersionIos" :label="$t('settings.settings.minorVersionIos')"
                  type="text" style="margin-top: 15px"></v-text-field>
                <label style="font-size: large">{{ $t("settings.settings.majorVersionIosLabel") }}</label>
                <v-text-field outline v-model="model.customerAppMajorVersionIos" :label="$t('settings.settings.majorVersionIos')"
                  type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settings.settings.minDistanceUnblockLabel") }}</label>
                <v-text-field outline v-model="model.unavailable_distance_unblock" :label="$t('settings.settings.minDistanceUnblock')"
                  type="text" style="margin-top: 15px"></v-text-field>
                <label style="font-size: large">{{ $t("settings.settings.frozenLocationDurationLabel") }}</label>
                <v-text-field outline v-model="model.unavailable_distance_block_time" :label="$t('settings.settings.frozenLocationDuration')"
                  type="text" style="margin-top: 15px"></v-text-field>

                <label style="font-size: large">{{ $t("settings.settings.disableSameLocationBlock") }}</label>
                <v-switch color="red" v-model="model.disable_same_location_block" :false-value="0" :true-value="1"></v-switch>

            







                <v-btn :loading="loading" block @click="save" color="secondary">{{ $t("settings.settings.save") }}
                </v-btn>
              </v-form>
            </v-flex>
            <!--</v-responsive>-->
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  title() {
    return this.$t("settings.settings.title");
  },
  data: () => ({
    loading: false,
    form: false,
    settings: {},
    model: {
      instantSuggestion: 0,
      reservationSuggestion: 0,
      lemonwayId: "",
      besoin: "",
      instant: "",
      redistribute: "",
      geo_fence: "",
      block_period: "",
      price_per_minute: "",
      customerAppMajorVersion: "",
      customerAppMinorVersion: "",
      short_reservation: 0,
      disable_same_location_block: 0,
      unavailable_distance_unblock: 0,
      unavailable_distance_block_time: 0,
      seasonal_besoin_allowance_start_time: "",
      seasonal_besoin_allowance_end_time: "",
      company_email: ""
    },
  }),
  mounted() {
    axios.get("setting").then((response) => {
      this.settings = response.data.data;
      this.model.instantSuggestion = this.settings.CAPTAIN_SUGGESTION_TIME_IN_SECONDS_INSTANT;
      this.model.reservationSuggestion = this.settings.CAPTAIN_SUGGESTION_TIME_IN_SECONDS_RESERVATION;
      this.model.lemonwayId = this.settings.LEMONWAY_ID;
      this.model.instant = this.settings.MINIMUM_RESERVATION;
      this.model.besoin = this.settings.MINIMUM_BESOIN;
      this.model.redistribute = this.settings.REDISTRIBUTION_LIMIT;
      this.model.geo_fence = this.settings.GEO_FENCE;
      this.model.block_period = this.settings.BLOCK_PERIOD;
      this.model.price_per_minute = this.settings.PRICE_PER_MINUTE;
      this.model.customerAppMajorVersionAndroid = this.settings.CUSTOMER_APP_MAJOR_VERSION_ANDROID;
      this.model.customerAppMinorVersionAndroid = this.settings.CUSTOMER_APP_MINOR_VERSION_ANDROID;
      this.model.customerAppMajorVersionIos = this.settings.CUSTOMER_APP_MAJOR_VERSION_IOS;
      this.model.customerAppMinorVersionIos = this.settings.CUSTOMER_APP_MINOR_VERSION_IOS;
      this.model.short_reservation = parseInt(this.settings.SHORT_RESERVATION);
      this.model.disable_same_location_block = parseInt(this.settings.DISABLE_SAME_LOCATION_BLOCK);
      this.model.unavailable_distance_unblock = parseInt(this.settings.UNAVAILABLE_DISTANCE_UNBLOCK);
      this.model.unavailable_distance_block_time = parseInt(this.settings.UNAVAILABLE_DISTANCE_BLOCK_TIME);
     
      this.model.company_email = this.settings.COMPANY_EMAIL;
    });
  },

  methods: {
    allowedMinutes: (v) => v == 15 || v == 30 || v == 45 || v == 0,
    save() {
      if (!this.$refs.form.validate()) {
        window.getApp.$emit(
          "SHOW_TOAST",
          this.$t("settings.settings.invalidNumber"),
          "red"
        );
        return;
      }


      this.loading = true;
      let setty = {};
      if (this.model.instantSuggestion) {
        setty.CAPTAIN_SUGGESTION_TIME_IN_SECONDS_INSTANT = this.model.instantSuggestion;
      }
      if (this.model.reservationSuggestion) {
        setty.CAPTAIN_SUGGESTION_TIME_IN_SECONDS_RESERVATION = this.model.reservationSuggestion;
      }
      if (this.model.lemonwayId) {
        setty.LEMONWAY_ID = this.model.lemonwayId;
      }
      if (this.model.instant) {
        setty.MINIMUM_RESERVATION = this.model.instant;
      }
      if (this.model.besoin) {
        setty.MINIMUM_BESOIN = this.model.besoin;
      }
      if (this.model.redistribute) {
        setty.REDISTRIBUTION_LIMIT = this.model.redistribute;
      }
      if (this.model.geo_fence) {
        setty.GEO_FENCE = this.model.geo_fence;
      }
      if (this.model.block_period) {
        setty.BLOCK_PERIOD = this.model.block_period;
      }
      if (this.model.price_per_minute) {
        setty.PRICE_PER_MINUTE = this.model.price_per_minute;
      }
      if (this.model.customerAppMajorVersionAndroid) {

        setty.CUSTOMER_APP_MAJOR_VERSION_ANDROID = this.model.customerAppMajorVersionAndroid;
      }
      if (this.model.customerAppMinorVersionAndroid) {
        setty.CUSTOMER_APP_MINOR_VERSION_ANDROID = this.model.customerAppMinorVersionAndroid;
      }
      if (this.model.customerAppMajorVersionIos) {

        setty.CUSTOMER_APP_MAJOR_VERSION_IOS = this.model.customerAppMajorVersionIos;
      }
      if (this.model.customerAppMinorVersionIos) {
        setty.CUSTOMER_APP_MINOR_VERSION_IOS = this.model.customerAppMinorVersionIos;
      }
    
      if (this.model.company_email) {
        setty.COMPANY_EMAIL = this.model.company_email;
      }
      setty.SHORT_RESERVATION = this.model.short_reservation;
      setty.DISABLE_SAME_LOCATION_BLOCK = this.model.disable_same_location_block;
      setty.UNAVAILABLE_DISTANCE_UNBLOCK = this.model.unavailable_distance_unblock;
      setty.UNAVAILABLE_DISTANCE_BLOCK_TIME = this.model.unavailable_distance_block_time;
      console.log(setty);
      this.axios
        .put(`setting/update`, setty)
        .then(() => window.getApp.$emit("SHOW_TOAST", this.$t("settings.settings.saved")))
        .catch(({ response }) => {
          window.getApp.$emit("SHOW_TOAST", this.$t("settings.settings.saveFailed"), "red");
          console.log(response);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.time-container {
  display: flex;
}

.time-left,
.time-right {
  flex: 1;
  padding: 10px;
}
</style>
